import * as _ from 'underscore';
import * as $ from 'jquery';

import { themeFields } from '../themes/themeFields';
import { ChartElementsFormatKeys } from './ChartElementsFormatSelect';
import { ChartPropsManager } from '../ChartPropsManager';
import { ChartAxisWrapper } from './ChartAxisWrapper';

import {
    C2F_Multi,
    FontWrapper,
    LabelsFormatWrapper,
    SeriesXY_PointLabel_Wrapper
} from '../DashboardWidget_dxChart_Parametrized';

export default class TooltipWrapper {
    public static createTooltip_forXY(
        wParams,
        chartWidgetObj,
        _ArgumentAndPointLabels,
        _ArgumentAndPointLabels_Groups,
        _arrArgumentAndPointLabels,
        _arrArgumentAndPointLabels_Groups,
        _argType,
        _argTimePart,
        _yTimePart,
        _aTimeParts,
        _theme
    ) {
        let shared = false; // is default in DevExpr
        if (wParams.tooltips != null && wParams.tooltips.shared === true) {
            shared = true;
        }

        let backcolor = '#ffffff'; // white is default in DevExpr
        if (wParams.tooltips != null && wParams.tooltips.backcolor != null) {
            backcolor = wParams.tooltips.backcolor;
        }

        let fontColor = '#232323'; // is default in DevExpr
        if (wParams.tooltips != null && wParams.tooltips.fontColor != null) {
            fontColor = wParams.tooltips.fontColor;
        }

        let fontObj: any = {
            color: fontColor
        };
        let fo = FontWrapper.createFontObj_fromTheme(wParams, _theme, themeFields.font_inTooltip);
        _.extend(fontObj, fo); // shallow

        let enabled = true;
        //LL:  for mobile:
        if (wParams.tooltips != null && wParams.tooltips.hide === true) {
            enabled = false;
        } else {
            if (wParams.tooltips != null && wParams.tooltips.enabled === false) {
                enabled = false;
            }
        }

        let tooltip: any = {
            enabled: enabled,
            font: fontObj,
            color: backcolor,
            shared: shared,

            // Return Value: Object - Specifies the text to be displayed in a tooltip and a color for the tooltip.
            // - valueText (for candle stick and stock series)
            //    Specifies a string of the values of the currently represented point. This string contains the highValueText, openValueText, closeValueText and lowValueText values.
            //    The format of the string is the following: "h: %highValueText% o: %openValueText% c: %closeValueText% l: %lowValueText%".
            // - valueText (for range area and range bar series)
            //    Specifies a string of the values of the currently represented point. This string contains the rangeValue1Text and rangeValue2Text values.
            //    The format of the string is the following: "%rangeValue1Text% - %rangeValue2Text%".
            customizeTooltip: function (pointInfo): any {
                //LL: how to get actual Series Color:  ser.getColor()
                //    "ser" is obtained for example in onSeriesClick, or here in pointInfo.point.series

                //LL: when "shared", there is pointInfo.points - array[number of series]
                let multi = false;
                if (shared && pointInfo.points != null && pointInfo.points.length > 1) {
                    multi = true;
                }

                let byHTML = true;
                let before = '\n';
                let after = '';
                //LL: Leo does not like with " ( ... ) ", use new line
                //if (byHTML) {
                //    before = ' (';
                //    let after = ')';
                //}

                let seriesTag = pointInfo.point.series.tag;

                var getTooltipForTooltip = function () {
                    let sA = '';
                    if (seriesTag == null || seriesTag.T_ref == null) {
                        return sA;
                    }

                    let tooltipValue = pointInfo.point.data.T;
                    let tooltipText = LabelsFormatWrapper.getFormatted(
                        tooltipValue,
                        null,
                        seriesTag,
                        'T_formats',
                        wParams.currency,
                        'Tooltip'
                    );

                    sA += tooltipText;
                    return sA;
                };

                var getTooltipForArgument = function () {
                    if (seriesTag != null) {
                        let x_showInTooltip = seriesTag.x_showInTooltip;
                        if (x_showInTooltip == null) {
                            x_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.X1;
                        }
                        if (x_showInTooltip != true) {
                            return null;
                        }
                    }

                    let sA = '';
                    if (seriesTag != null) {
                        if (seriesTag.x != null) {
                            sA += seriesTag.x + ' = ';
                        }
                    }

                    let argText = LabelsFormatWrapper.getFormattedArgument(
                        pointInfo,
                        wParams,
                        chartWidgetObj,
                        _argTimePart,
                        'Tooltip'
                    );

                    sA += argText;
                    return sA;
                };

                //LL:  Leo wants to display "Bar Color" value if set (as in D3)
                var getTooltipForPointColor = function (_pointInfo) {
                    let labelText;
                    let _seriesTag = _pointInfo.point.series.tag;
                    if (_seriesTag != null) {
                        let xc_showInTooltip = _seriesTag.xc_showInTooltip;
                        if (xc_showInTooltip == null) {
                            xc_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.XC;
                        }
                        if (xc_showInTooltip != true) {
                            return labelText;
                        }

                        let counts = _seriesTag.counters;
                        if (
                            counts != null &&
                            ((counts.xcCount != null && counts.xcCount > 0) ||
                                (counts.xcCount_group != null && counts.xcCount_group > 0))
                        ) {
                            //LL: note: also there is counts.xcAttrib   not needed here

                            labelText = '';
                            if (_seriesTag.xc_label != null) {
                                labelText += _seriesTag.xc_label + ' = ';
                            }

                            //LL: for groupped:
                            if (_seriesTag.x2 != null || _seriesTag.x3 != null) {
                                //LL:  or use _ArgumentAndPointLabels_Groups ?
                                if (
                                    _pointInfo.point != null &&
                                    _pointInfo.point.data != null &&
                                    _pointInfo.point.data.colorValue != null
                                ) {
                                    let c = _pointInfo.point.data.colorValue;
                                    c = LabelsFormatWrapper.getFormatted(
                                        c,
                                        null,
                                        _seriesTag,
                                        'xc_formats',
                                        wParams.currency,
                                        'Tooltip',
                                        'pointColor'
                                    );
                                    labelText += c;
                                }
                                return labelText;
                            }

                            //LL: when no X2/X3:

                            //LL: try without APL (APL is wrong when group aggreg in XC)
                            if (
                                _pointInfo.point != null &&
                                _pointInfo.point.data != null &&
                                _pointInfo.point.data.colorValue != null
                            ) {
                                let c = _pointInfo.point.data.colorValue;
                                c = LabelsFormatWrapper.getFormatted(
                                    c,
                                    null,
                                    _seriesTag,
                                    'xc_formats',
                                    wParams.currency,
                                    'Tooltip',
                                    'pointColor'
                                );
                                labelText += c;
                                return labelText;
                            }

                            //LL: was with APL:
                            let apl = _ArgumentAndPointLabels;
                            let counterId = counts.counterId;

                            if (_arrArgumentAndPointLabels != null && _arrArgumentAndPointLabels.length > counterId) {
                                apl = _arrArgumentAndPointLabels[counterId];
                            }

                            if (apl != null) {
                                if (apl[_pointInfo.argument] != null) {
                                    let c = apl[_pointInfo.argument].color;
                                    if (c != null) {
                                        c = LabelsFormatWrapper.getFormatted(
                                            c,
                                            null,
                                            _seriesTag,
                                            'xc_formats',
                                            wParams.currency,
                                            'Tooltip',
                                            'pointColor'
                                        );
                                        labelText += c;
                                    }
                                } else {
                                    if (
                                        _pointInfo.point != null &&
                                        _pointInfo.point.data != null &&
                                        _pointInfo.point.data.colorValue != null
                                    ) {
                                        labelText += _pointInfo.point.data.colorValue;
                                    }
                                }
                            }
                        }
                    }

                    return labelText;
                };

                var getCustomPointLabel = function (_pointInfo, formatConfigKeyMinor) {
                    let labelText;
                    let _seriesTag = _pointInfo.point.series.tag;

                    if (_seriesTag != null) {
                        let xP_showInTooltip = _seriesTag.xP_showInTooltip;
                        if (xP_showInTooltip == null) {
                            xP_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.XP;
                        }
                        if (xP_showInTooltip != true) {
                            return labelText;
                        }
                    }

                    //LL: can be for Scatter:  xpCount_group   //LL: always
                    //  It is spec case for Scatter:
                    //      "Point Label" axis has aggreg = 'group'
                    //      "Arguments" has aggr != 'group'
                    //      So only grouping is by "Point Label" (validated)

                    let counts = _seriesTag.counters;
                    if (
                        _seriesTag != null &&
                        counts != null &&
                        ((counts.xpCount != null && counts.xpCount > 0) ||
                            (counts.xpCount_group != null && counts.xpCount_group > 0))
                    ) {
                        let argCount = counts.argCount;
                        let counterId = counts.counterId;

                        if (argCount === 1) {
                            let apl = _ArgumentAndPointLabels;
                            if (_arrArgumentAndPointLabels != null && _arrArgumentAndPointLabels.length > counterId) {
                                apl = _arrArgumentAndPointLabels[counterId];
                            }
                            if (apl != null) {
                                if (apl[_pointInfo.argument] != null) {
                                    let pl = apl[_pointInfo.argument].pointLabel;
                                    //LL: try formats
                                    if (pl != null && pl != '') {
                                        labelText = LabelsFormatWrapper.getFormatted(
                                            pl,
                                            null,
                                            _seriesTag,
                                            'xP_formats',
                                            wParams.currency,
                                            formatConfigKeyMinor,
                                            'pointLabel'
                                        );
                                    }
                                }
                            }
                        }

                        if (argCount === 2) {
                            let groupOnly = _seriesTag.groupOnly;

                            let apl2 = _ArgumentAndPointLabels_Groups;
                            if (
                                _arrArgumentAndPointLabels_Groups != null &&
                                _arrArgumentAndPointLabels_Groups.length > counterId
                            ) {
                                apl2 = _arrArgumentAndPointLabels_Groups[counterId];
                            }
                            if (apl2 != null) {
                                if (apl2[groupOnly] != null) {
                                    let pl = apl2[groupOnly].pointLabel;
                                    //LL: try formats
                                    if (pl != null && pl != '') {
                                        labelText = LabelsFormatWrapper.getFormatted(
                                            pl,
                                            null,
                                            _seriesTag,
                                            'xP_formats',
                                            wParams.currency,
                                            formatConfigKeyMinor,
                                            'pointLabel'
                                        );
                                    }
                                }
                            }
                        }

                        if (argCount === 3) {
                            let group = _seriesTag.group;
                            let stack = _seriesTag.stack;

                            let apl3 = _ArgumentAndPointLabels_Groups;
                            if (
                                _arrArgumentAndPointLabels_Groups != null &&
                                _arrArgumentAndPointLabels_Groups.length > counterId
                            ) {
                                apl3 = _arrArgumentAndPointLabels_Groups[counterId];
                            }
                            if (apl3 != null) {
                                if (apl3[group] != null && apl3[group][stack] != null) {
                                    let pl = apl3[group][stack].pointLabel;
                                    if (pl != null && pl != '') {
                                        labelText = LabelsFormatWrapper.getFormatted(
                                            pl,
                                            null,
                                            _seriesTag,
                                            'xP_formats',
                                            wParams.currency,
                                            formatConfigKeyMinor,
                                            'pointLabel'
                                        );
                                    }
                                }
                            }
                        }
                    }
                    return labelText;
                };

                var getTooltipForPoint = function (_pointInfo) {
                    let sP = '';
                    let _seriesTag = _pointInfo.point.series.tag;

                    let chartType = wParams.chartType;
                    if (_seriesTag != null) {
                        if (_seriesTag.ownChartType != null) {
                            chartType = _seriesTag.ownChartType;
                        }
                    }

                    //LL: same as for LabelXY:
                    let ownAxis = SeriesXY_PointLabel_Wrapper.get_ownAxis(_pointInfo);

                    if (chartType == 'candlestick' || chartType == 'stock') {
                        let o_showInTooltip = true;
                        let c_showInTooltip = true;
                        let h_showInTooltip = true;
                        let l_showInTooltip = true;
                        if (_seriesTag != null) {
                            o_showInTooltip = _seriesTag.o_showInTooltip;
                            c_showInTooltip = _seriesTag.c_showInTooltip;
                            h_showInTooltip = _seriesTag.h_showInTooltip;
                            l_showInTooltip = _seriesTag.l_showInTooltip;
                            if (o_showInTooltip == null) {
                                o_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Y_Open;
                            }
                            if (c_showInTooltip == null) {
                                c_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Y_Close;
                            }
                            if (h_showInTooltip == null) {
                                h_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Y_High;
                            }
                            if (l_showInTooltip == null) {
                                l_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Y_Low;
                            }
                        }

                        let o = '';
                        let c = '';
                        let h = '';
                        let l = '';
                        if (_seriesTag != null) {
                            let t = _seriesTag;
                            if (t.o != null && t.o != '') {
                                o = ' (' + t.o + ')';
                            }
                            if (t.c != null && t.c != '') {
                                c = ' (' + t.c + ')';
                            }
                            if (t.h != null && t.h != '') {
                                h = ' (' + t.h + ')';
                            }
                            if (t.l != null && t.l != '') {
                                l = ' (' + t.l + ')';
                            }
                        }

                        let oV: any = _pointInfo.openValue;
                        let cV: any = _pointInfo.closeValue;
                        let hV: any = _pointInfo.highValue;
                        let lV: any = _pointInfo.lowValue;

                        if (
                            o_showInTooltip === true ||
                            c_showInTooltip === true ||
                            h_showInTooltip === true ||
                            l_showInTooltip === true
                        ) {
                            sP += '\n';
                        }
                        if (o_showInTooltip === true) {
                            oV = LabelsFormatWrapper.getFormatted(
                                oV,
                                _pointInfo.openValueText,
                                _seriesTag,
                                'o_formats',
                                wParams.currency,
                                'Tooltip'
                            );
                            sP += '\nopenValue' + o + ' = ' + oV;
                        }
                        if (c_showInTooltip === true) {
                            cV = LabelsFormatWrapper.getFormatted(
                                cV,
                                _pointInfo.closeValueText,
                                _seriesTag,
                                'c_formats',
                                wParams.currency,
                                'Tooltip'
                            );
                            sP += '\ncloseValue' + c + ' = ' + cV;
                        }
                        if (h_showInTooltip === true) {
                            hV = LabelsFormatWrapper.getFormatted(
                                hV,
                                _pointInfo.highValueText,
                                _seriesTag,
                                'h_formats',
                                wParams.currency,
                                'Tooltip'
                            );
                            sP += '\nhighValue' + h + ' = ' + hV;
                        }
                        if (l_showInTooltip === true) {
                            lV = LabelsFormatWrapper.getFormatted(
                                lV,
                                _pointInfo.lowValueText,
                                _seriesTag,
                                'l_formats',
                                wParams.currency,
                                'Tooltip'
                            );
                            sP += '\nlowValue' + l + ' = ' + lV;
                        }
                    } else if (chartType == 'rangearea' || chartType == 'rangebar') {
                        let yMin_showInTooltip = true;
                        let yMax_showInTooltip = true;
                        if (_seriesTag != null) {
                            yMin_showInTooltip = _seriesTag.yMin_showInTooltip;
                            yMax_showInTooltip = _seriesTag.yMax_showInTooltip;
                            if (yMin_showInTooltip == null) {
                                yMin_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Y_Min;
                            }
                            if (yMax_showInTooltip == null) {
                                yMax_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Y_Max;
                            }
                        }

                        //=========================================
                        //LL: see in docs:
                        //  - valueText (for range area and range bar series)
                        //      Specifies a string of the values of the currently represented point.
                        //         This string contains the rangeValue1Text and rangeValue2Text values.
                        //      The format of the string is the following: "%rangeValue1Text% - %rangeValue2Text%".
                        //
                        // - originalMinValue
                        //Specifies the first range value of the currently hovered point as it is set in the data source.
                        // - rangeValue1
                        //Specifies the first range value of the currently hovered point.
                        // Differs from the originalMinValue when the axis value type is specified explicitly.
                        // In this instance, the rangeValue1 field contains the first range value in the specified type.
                        // - rangeValue1Text
                        //Specifies the first range value of the currently hovered point with applied formatting if the format property is specified.
                        //=========================================

                        //sP += "\n" + _pointInfo.seriesName + ":";
                        ////LL:  tag = { yMin_formats: attr1.formats, yMax_formats: attr2.formats };
                        //let vTextRange = _pointInfo.valueText;  //LL: _pointInfo.valueText = "min - max" by default
                        //if (_seriesTag != null && (_seriesTag.yMin_formats != null || _seriesTag.yMax_formats != null) ) {
                        //    let yMin = _pointInfo.rangeValue1Text;
                        //    if (_seriesTag.yMin_formats != null && (_seriesTag.yMin_formats[ChartElementsFormatKeys.inTooltip] != null || _seriesTag.yMin_formats[ChartElementsFormatKeys.everywhere] != null)) {
                        //        yMin = LabelsFormatWrapper.getFormatted(_pointInfo.rangeValue1, _pointInfo.rangeValue1Text, _seriesTag, "yMin_formats", wParams.currency, "Tooltip");
                        //    }
                        //    let yMax = _pointInfo.rangeValue2Text;
                        //    if (_seriesTag.yMax_formats != null && (_seriesTag.yMax_formats[ChartElementsFormatKeys.inTooltip] != null || _seriesTag.yMax_formats[ChartElementsFormatKeys.everywhere] != null)) {
                        //        yMax = LabelsFormatWrapper.getFormatted(_pointInfo.rangeValue2, _pointInfo.rangeValue2Text, _seriesTag, "yMax_formats", wParams.currency, "Tooltip");
                        //    }
                        //    vTextRange = yMin + " - " + yMax;
                        //}
                        //sP += "\n" + vTextRange;

                        let yMin: any, yMax: any;
                        if (yMin_showInTooltip === true) {
                            yMin = _pointInfo.rangeValue1Text;
                            if (
                                _seriesTag != null &&
                                _seriesTag.yMin_formats != null &&
                                (_seriesTag.yMin_formats[ChartElementsFormatKeys.inTooltip] != null ||
                                    _seriesTag.yMin_formats[ChartElementsFormatKeys.everywhere] != null)
                            ) {
                                yMin = LabelsFormatWrapper.getFormatted(
                                    _pointInfo.rangeValue1,
                                    _pointInfo.rangeValue1Text,
                                    _seriesTag,
                                    'yMin_formats',
                                    wParams.currency,
                                    'Tooltip'
                                );
                            }
                        }
                        if (yMax_showInTooltip === true) {
                            yMax = _pointInfo.rangeValue2Text;
                            if (
                                _seriesTag != null &&
                                _seriesTag.yMax_formats != null &&
                                (_seriesTag.yMax_formats[ChartElementsFormatKeys.inTooltip] != null ||
                                    _seriesTag.yMax_formats[ChartElementsFormatKeys.everywhere] != null)
                            ) {
                                yMax = LabelsFormatWrapper.getFormatted(
                                    _pointInfo.rangeValue2,
                                    _pointInfo.rangeValue2Text,
                                    _seriesTag,
                                    'yMax_formats',
                                    wParams.currency,
                                    'Tooltip'
                                );
                            }
                        }

                        if (yMin_showInTooltip === true && yMax_showInTooltip === true) {
                            sP += '\n' + _pointInfo.seriesName + ':';
                            let vTextRange = _pointInfo.valueText; //LL: _pointInfo.valueText = "min - max" by default
                            if (yMin != null && yMax != null) {
                                vTextRange = yMin + ' - ' + yMax;
                            }
                            sP += '\n' + vTextRange;
                        } else if (yMin_showInTooltip === true) {
                            let yMin_label =
                                _seriesTag != null && _seriesTag.yMin_label != null ? _seriesTag.yMin_label : '';
                            sP += '\nminValue' + ' (' + yMin_label + ')' + ' = ' + yMin;
                        } else if (yMax_showInTooltip === true) {
                            let yMax_label =
                                _seriesTag != null && _seriesTag.yMax_label != null ? _seriesTag.yMax_label : '';
                            sP += '\nmaxValue' + ' (' + yMax_label + ')' + ' = ' + yMax;
                        }
                    } else {
                        let valueTxt;
                        let y_showInTooltip = true;
                        if (_seriesTag != null) {
                            y_showInTooltip = _seriesTag.y_showInTooltip;
                            if (y_showInTooltip == null) {
                                y_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Y;
                            }
                        }

                        if (y_showInTooltip === true) {
                            let tp = _yTimePart;
                            if (ownAxis != null && _aTimeParts != null && _aTimeParts[ownAxis] != null) {
                                tp = _aTimeParts[ownAxis];
                            }
                            valueTxt = LabelsFormatWrapper.getFormattedValue(
                                _pointInfo,
                                wParams,
                                chartWidgetObj,
                                tp,
                                ownAxis,
                                'Tooltip'
                            );
                        }

                        if (_seriesTag == null) {
                            if (valueTxt != null) {
                                sP += _pointInfo.seriesName + ' = ' + valueTxt;
                            }
                        } else {
                            if (_seriesTag.y != null) {
                                if (valueTxt != null) {
                                    sP += _seriesTag.y + ' = ' + valueTxt;
                                    //LL: for fullStacked:
                                    if (wParams.fullStacked === true && _pointInfo.percentText != null) {
                                        sP += ' (' + _pointInfo.percentText + ')';
                                    }
                                }
                            }

                            if (_seriesTag.groupOnly != null) {
                                let group = '';

                                let showInTooltip_Field;
                                let formatsField;
                                let formatConfigKey;
                                if (_seriesTag.x2 != null) {
                                    group = _seriesTag.x2;
                                    formatConfigKey = 'sbs';
                                    formatsField = 'x2_formats';
                                    showInTooltip_Field = 'x2_showInTooltip';
                                } else if (_seriesTag.x3 != null) {
                                    group = _seriesTag.x3;
                                    formatConfigKey = 'stacked';
                                    formatsField = 'x3_formats';
                                    showInTooltip_Field = 'x3_showInTooltip';
                                }

                                let showInTooltip = true;
                                if (_seriesTag != null) {
                                    showInTooltip = _seriesTag[showInTooltip_Field];
                                    if (showInTooltip == null) {
                                        showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.X2; // X2, X3 same
                                    }
                                }

                                if (showInTooltip === true) {
                                    let groupValue = _seriesTag.groupOnly;
                                    groupValue = LabelsFormatWrapper.getFormatted(
                                        groupValue,
                                        null,
                                        _seriesTag,
                                        formatsField,
                                        wParams.currency,
                                        'Tooltip',
                                        formatConfigKey
                                    );
                                    if (group != '') {
                                        sP += before + group + ' = ' + groupValue + after;
                                    } //  "\n"
                                }
                            }

                            if (
                                _seriesTag.group != null &&
                                _seriesTag.stack != null &&
                                _seriesTag.x2 != null &&
                                _seriesTag.x3 != null
                            ) {
                                //LL: x2-x3 vice versa !!!

                                let x2_showInTooltip = true;
                                let x3_showInTooltip = true;
                                if (_seriesTag != null) {
                                    x2_showInTooltip = _seriesTag.x2_showInTooltip;
                                    x3_showInTooltip = _seriesTag.x3_showInTooltip;
                                    if (x2_showInTooltip == null) {
                                        x2_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.X2;
                                    }
                                    if (x3_showInTooltip == null) {
                                        x3_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.X3;
                                    }
                                }

                                // x3:
                                let valueX3: any;
                                if (x3_showInTooltip === true) {
                                    valueX3 = _seriesTag.group; //LL: x2-x3 vice versa !!!
                                    let formatsField3 = 'x3_formats';
                                    valueX3 = LabelsFormatWrapper.getFormatted(
                                        valueX3,
                                        null,
                                        _seriesTag,
                                        formatsField3,
                                        wParams.currency,
                                        'Tooltip',
                                        'stacked'
                                    );
                                }

                                // x2:
                                let valueX2: any;
                                if (x2_showInTooltip === true) {
                                    valueX2 = _seriesTag.stack; //LL: x2-x3 vice versa !!!
                                    let formatsField2 = 'x2_formats';
                                    valueX2 = LabelsFormatWrapper.getFormatted(
                                        valueX2,
                                        null,
                                        _seriesTag,
                                        formatsField2,
                                        wParams.currency,
                                        'Tooltip',
                                        'sbs'
                                    );
                                }

                                if (valueX3 != null && valueX2 != null) {
                                    sP += before + _seriesTag.x3 + ' = ' + valueX3;
                                    sP += '\n' + _seriesTag.x2 + ' = ' + valueX2 + after;
                                } else if (valueX3 != null) {
                                    sP += before + _seriesTag.x3 + ' = ' + valueX3 + after;
                                } else if (valueX2 != null) {
                                    sP += before + _seriesTag.x2 + ' = ' + valueX2 + after;
                                }
                            }
                        }

                        if (chartType == 'bubble') {
                            let zSize_showInTooltip = true;
                            if (_seriesTag != null) {
                                zSize_showInTooltip = _seriesTag.zSize_showInTooltip;
                                if (zSize_showInTooltip == null) {
                                    zSize_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.Z_Size;
                                }
                            }

                            if (zSize_showInTooltip === true) {
                                if (
                                    _seriesTag != null &&
                                    (_seriesTag.isAuxAxis != true || _seriesTag.ownChartType != null)
                                ) {
                                    let sz = _pointInfo.size;
                                    let szFormatted = SeriesXY_PointLabel_Wrapper.formatSizeText(wParams, sz, ownAxis); //LL: default for zSize in ValueAxis
                                    if (_seriesTag != null && _seriesTag.zSize_formats != null) {
                                        szFormatted = LabelsFormatWrapper.getFormatted(
                                            sz,
                                            szFormatted,
                                            _seriesTag,
                                            'zSize_formats',
                                            wParams.currency,
                                            'Tooltip'
                                        );
                                    }

                                    let ss = 'size';
                                    //LL: tag: label in getDataSource
                                    //LL: tag: zSize is series
                                    if (_seriesTag != null && _seriesTag.zSize != null) {
                                        ss = _seriesTag.zSize;
                                    }

                                    sP += before + ss + ' = ' + szFormatted + after; //  "\n"
                                }
                            }
                        }
                    }

                    //LL: 04.04.25: XL not shown in tooltip
                    let xL_showInTooltip = false;
                    if (_seriesTag != null) {
                        xL_showInTooltip = _seriesTag.xL_showInTooltip;
                        if (xL_showInTooltip == null) {
                            xL_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.XL;
                        }
                    }
                    if (xL_showInTooltip === true) {
                        let xL = pointInfo.point.data.nameLabel || '';
                        sP += before + _seriesTag.xL_label + ' = ' + xL + after;
                    }
                    //LL: 07.04.25: XP not shown in tooltip
                    let xP_showInTooltip = false;
                    if (_seriesTag != null) {
                        xP_showInTooltip = _seriesTag.xP_showInTooltip;
                        if (xP_showInTooltip == null) {
                            xP_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.XP;
                        }
                    }
                    if (xP_showInTooltip === true) {
                        let xP = pointInfo.point.data.namePoint || '';
                        sP += before + _seriesTag.xP_label + ' = ' + xP + after;
                    }

                    //LL: multi C2F:   Roles: C2F_group, C2F_nogroup   when C2F_Multi = true
                    if (C2F_Multi !== true) {
                        let C2F_showInTooltip = false;

                        if (_seriesTag != null) {
                            C2F_showInTooltip = _seriesTag.C2F_showInTooltip;
                            if (C2F_showInTooltip == null) {
                                C2F_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.C2F;
                            }
                        }

                        if (C2F_showInTooltip === true) {
                            let C2F = pointInfo.point.data.C2F;
                            //if (C2F != null) { }
                            sP += before + _seriesTag.C2F_label + ' = ' + C2F + after;
                        }
                    }
                    //LL: multi C2F:   Roles: C2F_group, C2F_nogroup  when C2F_Multi = true
                    else {
                        // see 'A' below
                        if (_seriesTag != null) {
                            let roleC2Fs = _seriesTag.roleC2Fs;
                            if (roleC2Fs != null) {
                                //LL:  order of roleC2Fs must be the same as in point.data.A: 1) Groups 2) Attrs
                                let aa = pointInfo.point.data.C2F;
                                for (let ia: number = 0; ia < roleC2Fs.length; ia++) {
                                    let ra: any = roleC2Fs[ia];

                                    let C2F_showInTooltip = false;
                                    C2F_showInTooltip = ra.C2F_showInTooltip;
                                    if (C2F_showInTooltip == null) {
                                        C2F_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.C2F;
                                    }

                                    if (C2F_showInTooltip === true) {
                                        let A = aa[ia];
                                        if (A != null) {
                                            A = LabelsFormatWrapper.getFormatted(
                                                A,
                                                null,
                                                ra,
                                                'C2F_formats',
                                                wParams.currency,
                                                'Tooltip'
                                            );
                                        }
                                        sP += before + ra.C2F_label + ' = ' + A + after;
                                    }
                                }
                            }
                        }
                    }

                    //LL:  they can be many !!!!!!!!!
                    if (_seriesTag != null) {
                        let roleAttributes = _seriesTag.roleAttributes;
                        if (roleAttributes != null) {
                            //LL:  order of roleAttributes must be the same as in point.data.A: 1) Groups 2) Attrs
                            let aa = pointInfo.point.data.A;
                            for (let ia: number = 0; ia < roleAttributes.length; ia++) {
                                let ra: any = roleAttributes[ia];

                                let A_showInTooltip = false;
                                A_showInTooltip = ra.A_showInTooltip;
                                if (A_showInTooltip == null) {
                                    A_showInTooltip = wParams.externalFunctions.ShowInTooltip_Defaults.A;
                                }

                                if (A_showInTooltip === true) {
                                    let A = aa[ia];
                                    if (A != null) {
                                        A = LabelsFormatWrapper.getFormatted(
                                            A,
                                            null,
                                            ra,
                                            'A_formats',
                                            wParams.currency,
                                            'Tooltip'
                                        );
                                    }
                                    sP += before + ra.A_label + ' = ' + A + after;
                                }
                            }
                        }
                    }

                    return sP;
                };

                var getTooltipForTotal = function (_pointInfo) {
                    let sT;
                    if (wParams.tooltips.showTotal === true) {
                        // "total", "totalText"   format ?

                        //LL: similar to valueTxt
                        let totalTxt = _pointInfo.totalText;
                        let tp = _yTimePart;
                        let ownAxis = SeriesXY_PointLabel_Wrapper.get_ownAxis(_pointInfo);
                        if (ownAxis != null && _aTimeParts != null && _aTimeParts[ownAxis] != null) {
                            tp = _aTimeParts[ownAxis];
                        }
                        totalTxt = LabelsFormatWrapper.getFormattedValue(
                            _pointInfo,
                            wParams,
                            chartWidgetObj,
                            tp,
                            ownAxis,
                            'Tooltip',
                            true
                        );

                        if (totalTxt != null) {
                            sT = totalTxt;
                        }
                    }
                    return sT;
                };

                var getTooltipForPercent = function (_pointInfo) {
                    let sT;
                    if (wParams.tooltips.showPercent === true) {
                        // "percent", "percentText"
                        //     percent: 0.5492957746478874 long-long !   percentText: "55 %"

                        //LL:  maybe here format is not needed ?  Yes

                        //LL: without formatting:
                        if (_pointInfo.percentText != null) {
                            sT = _pointInfo.percentText;
                        }
                    }
                    return sT;
                };

                if (byHTML) {
                    let html;

                    html = '<div>';
                    //LL: no sense, this div is inside
                    //    See div class="dxc-tooltip"  at the bottom of DOM
                    //html = "<div style='border-radius:5px'>";

                    if (seriesTag.counters.TCount > 0 || seriesTag.counters.TCount_group > 0) {
                        let t = getTooltipForTooltip();
                        html += '<p>' + t + '</p>';
                        html += '</div>';
                        return { html: html };
                    }

                    if (multi) {
                        //  argument before:  weight: 400  bolder   ; color:maroon
                        let argText = getTooltipForArgument();
                        if (argText != null) {
                            html += "<p style='font-weight:bold'>" + argText + '</p>';
                        }

                        for (let i = 0; i < pointInfo.points.length; i++) {
                            let pI = pointInfo.points[i];
                            let ser = pI.point.series;
                            let seriesColor = ser.getColor();
                            let text = getTooltipForPoint(pI);
                            //  custom point label ?
                            html +=
                                "<p> <span style='background:" +
                                seriesColor +
                                "'>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;" +
                                text +
                                '</p>';
                        }
                    } else {
                        let pI = pointInfo;
                        if (shared && pointInfo.points != null) {
                            pI = pointInfo.points[0];
                        }
                        //  custom point label
                        let labelText = getCustomPointLabel(pI, 'Tooltip');
                        if (labelText != null) {
                            html += '<p>' + labelText + '</p>';
                        }

                        let s = '';
                        s += getTooltipForPoint(pI);
                        //LL: Leo does not like with " ( ... ) ", use new line
                        let ss = s.split('\n');
                        for (let i = 0; i < ss.length; i++) {
                            html += '<p>' + ss[i] + '</p>';
                        }

                        //  argument last
                        let argText = getTooltipForArgument();
                        if (argText != null) {
                            html += '<p>' + argText + '</p>';
                        }

                        //LL:  Leo wants to display "Bar Color" value if set (as in D3)
                        let colorText = getTooltipForPointColor(pI);
                        if (colorText != null) {
                            html += '<p>' + colorText + '</p>';
                        }

                        //LL: for Total and Percent
                        let totalText = getTooltipForTotal(pI);
                        let percentText = getTooltipForPercent(pI);
                        if (totalText != null || percentText != null) {
                            html += '<p>' + '-----------------------' + '</p>';
                        }
                        if (totalText != null) {
                            html += '<p>' + 'Total = ' + totalText + '</p>';
                        }
                        if (percentText != null) {
                            html += '<p>' + 'Percent = ' + percentText + '</p>';
                        }
                    }
                    html += '</div>';

                    //LL: tsc issues a warning about wrong return value, but it works
                    return { html: html };
                    //return { html: html, color: "red" };
                    //return { color: "red" };
                } // byHTML

                // - as plain text:  NO

                if (multi) {
                    let sm = '';
                    //  argument before:
                    let argText = getTooltipForArgument();
                    if (argText != null) {
                        sm += argText;
                        sm += '\n\n';
                    }

                    for (let i = 0; i < pointInfo.points.length; i++) {
                        let pI = pointInfo.points[i];
                        let n = i + 1;
                        sm += '\n   series ' + n + ': \n' + getTooltipForPoint(pI);
                    }
                    sm += '\n\n';
                    return { text: sm };
                }

                let s = '';

                let pI = pointInfo;
                if (shared && pointInfo.points != null) {
                    pI = pointInfo.points[0];
                }

                let labelText = getCustomPointLabel(pI, 'Tooltip');
                if (labelText != null) {
                    s += labelText + '\n';
                }

                s += getTooltipForPoint(pI);

                //LL: Argument - the last as Leo's descr in WI 52098:
                let argText = getTooltipForArgument();
                if (argText != null) {
                    s += '\n';
                    s += argText;
                }

                return { text: s };
            }
        };

        if (ChartPropsManager.ApplyFormattedTimeParts || _argTimePart == null) {
            let fp = ChartAxisWrapper.getLabelFormatAndPrecision('x', wParams, _argType, _theme); // return { format: lf, precision: prec, custom: axis_customFormat, currency: currency };

            if (fp != null) {
                if (fp.format != null) {
                    tooltip.argumentFormat = fp.format;
                }
                let formatType = tooltip.argumentFormat;

                if (formatType != null && typeof formatType !== 'function') {
                    let toObj = false;
                    let currency;
                    if (!_.isObject(formatType) && formatType.indexOf('currency') >= 0 && wParams.currency != null) {
                        currency = wParams.currency;
                        if (fp.currency != null) {
                            currency = fp.currency;
                        }
                        toObj = true;
                    }
                    let precision;
                    if (fp.precision != null && !fp.custom && (_argType === 'i' || _argType === 'r')) {
                        precision = fp.precision;
                        toObj = true;
                    }
                    if (toObj) {
                        tooltip.argumentFormat = { type: formatType };
                    }
                    if (currency != null) {
                        tooltip.argumentFormat.currency = currency;
                    }
                    if (precision != null) {
                        tooltip.argumentFormat.precision = precision;
                    }
                }
            }
        }

        if (wParams.fullStacked === true) {
            //LL: tooltip.format is not defined in upper code, so can:
            tooltip.format = { percentPrecision: 2 };
        }

        return tooltip;
    }
}
